export default __webpack_public_path__ + "static/media/team_caroline_lloyd.c14da4d1.jpg";